// src/helpers/dateUtils.js

import dayjs from "dayjs";

/**
 * Returns true if both values represent the same instant in time
 * (same epoch milliseconds).
 *
 * Accepts Date objects or date strings.
 * Returns false if either value is invalid.
 *
 * @param {string|Date|null|undefined} first
 * @param {string|Date|null|undefined} second
 * @returns {boolean}
 */
export const isSameInstant = (first, second) => {
  // Fast path: same reference or same primitive value
  if (first === second) return true;

  // Explicitly handle nullish values
  if (first == null || second == null) return false;

  const d1 = dayjs(first);
  const d2 = dayjs(second);

  if (!d1.isValid() || !d2.isValid()) return false;

  return d1.valueOf() === d2.valueOf();
};

/**
 * Resolves a dirty date.
 * Returns null if the current value represents the same instant as the original,
 * otherwise returns the current value.
 *
 * @param {string|Date|null|undefined} original
 * @param {string|Date|null|undefined} current
 * @returns {string|Date|null}
 */
export const resolveDirtyDate = (original, current) => {
  return isSameInstant(original, current) ? null : current ?? null;
};
